import React, { useState, useEffect } from 'react';
import { PolarArea } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons"; // Ícone sugestivo para planos de saúde
import './dashCSS.css';
import api from '../conexao.js';
import { format } from 'date-fns';

// Registra os componentes necessários para o gráfico de Área Polar
ChartJS.register(
    RadialLinearScale,
    ArcElement,
    Tooltip,
    Legend
);

export default function DashPlanos() {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    });
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dataHoje = format(new Date(), 'yyyy-MM-dd');

                // 1. Busca inicial para obter o código do médico
                const initialResponse = await api.get('/imprimeagenda', {
                    params: { data: dataHoje 
                    }
                });
                const initialAgenda = initialResponse.data;

                if (!Array.isArray(initialAgenda) || initialAgenda.length === 0) {
                    setTotal(0);
                    setChartData({ labels: [], datasets: [] });
                    setLoading(false);
                    return; // Sai se não houver agendamentos
                }

                const codMedico = initialAgenda[0].COD_MEDICO;
                if (!codMedico) {
                    throw new Error("Nenhum médico encontrado na agenda de hoje.");
                }

                // 2. Busca detalhada com o código do médico para obter os planos
                const detailedResponse = await api.get('/imprimeagenda', {
                    params: {
                        cod_medico: codMedico,
                        data:  dataHoje
                    }
                });
                const agendaData = detailedResponse.data;

                if (!Array.isArray(agendaData)) {
                    throw new Error('Falha ao buscar dados detalhados da agenda');
                }

                // 3. Processa os dados para contar os planos
                const planCounts = agendaData.reduce((acc, current) => {
                    const planName = current.Paciente?.PLANO?.trim() || 'Particular';
                    acc[planName] = (acc[planName] || 0) + 1;
                    return acc;
                }, {});

                const labels = Object.keys(planCounts);
                const counts = Object.values(planCounts);
                const totalAgendamentos = counts.reduce((sum, count) => sum + count, 0);

                setTotal(totalAgendamentos);
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Pacientes',
                            data: counts,
                            backgroundColor: [
                                'rgba(99, 102, 241, 0.5)',   // Indigo
                                'rgba(20, 184, 166, 0.5)',    // Teal
                                'rgba(245, 158, 11, 0.5)',   // Amber
                                'rgba(239, 68, 68, 0.5)',    // Red
                                'rgba(132, 204, 22, 0.5)',   // Lime
                                'rgba(217, 70, 239, 0.5)',   // Fuchsia
                            ],
                            borderWidth: 1,
                        },
                    ],
                });

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    boxWidth: 20,
                    padding: 15,
                    color: 'black',
                }
            },
        },
        scales: {
            r: {
                ticks: {
                    backdropColor: 'transparent', // Fundo dos números transparente
                    stepSize: 1 // Garante que a escala seja de 1 em 1
                },
                grid: {
                    circular: true,
                },
            },
        },
    };

    if (loading) {
        return <div className="containerDash"><center>Carregando planos de saúde...</center></div>;
    }

    if (error) {
        return <div className="containerDash"><center>Erro: {error}</center></div>;
    }

    return (
        <center>
            <div className='containerDash'>
                <div>
                    <h5>Planos de Saúde (Hoje)</h5>
                    <h6>Total: {total}</h6>
                </div>
                <div><FontAwesomeIcon icon={faShieldAlt} size='xl' /></div>
            </div>
            <div className='containerGrafico'>
                 {chartData.labels.length > 0 ? (
                    <PolarArea data={chartData} options={chartOptions} />
                 ) : (
                    <p>Nenhum agendamento com plano encontrado para hoje.</p>
                 )}
            </div>
        </center>
    );
}